import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../Config';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployeeList, getOrganisationAgentList, getOrganisationDetail, getOrganisationList } from '../../../Redux/action/Organisation/OrganisationListAction';
import Beatloader from '../../../Common/Loaders/Beatloader';
import EditOrganisationOffcanvas from './EditOrganisationOffcanvas';
import GeneralTab from './Tabs/GeneralTab';
import ShipperTab from './Tabs/ShipperTab';
import ConsigneeTab from './Tabs/ConsigneeTab';
import ServicesTab from './Tabs/ServicesTab';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AgentTab from './Tabs/AgentTab';
import IATATab from './Tabs/IATATab';
import RegTab from './Tabs/RegTab';
import BasicTab from './Tabs/BasicTab';
import Select from "react-select";
import { customStyles } from '../../../HelperFunctions';



const OrganisationEdit = ({ OrganisationEdit }) => {

    const { b64id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(true);

    //offcanvas
    const [showEditForm, setShowEditForm] = useState(false);
    const handleCloseEditForm = () => { setShowEditForm(false) };
    const handleShowEditForm = () => { setShowEditForm(true); };

    const [activeTab, setActiveTab] = useState("basic");
    const [disableGeneralTab, setDisableGeneralTab] = useState(true);
    const [disableShipperTab, setDisableShipperTab] = useState(true);
    const [disableConsigneeTab, setDisableConsigneeTab] = useState(true);
    const [disableServicesTab, setDisableServicesTab] = useState(true);
    const [disableAgentTab, setDisableAgentTab] = useState(true);
    const [disableCarrierTab, setDisableCarrierTab] = useState(true);




    const initialValues = {
        has_sub_agent: false,
        sub_agent_id: 0,
        customerType: "Individual/Proprietary firm",
        name: "",
        alias: "",
        email: "",
        mobile: "",
        // gst_number: "",
        // service_type: "",
        entity_type: []
    };


    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        dispatch(getEmployeeList());
        if (token && user_id) {
            dispatch(getOrganisationList(token, user_id));
            let id = atob(b64id);
            if (id) {
                dispatch(getOrganisationDetail(id));
                dispatch(getOrganisationAgentList(token, user_id, id));
            } else {
                dispatch(getOrganisationAgentList(token, user_id));
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [b64id, token, user_id]);

    const refresh = () => {
        dispatch(getEmployeeList());
        if (token && user_id) {
            dispatch(getOrganisationList(token, user_id));
            let id = atob(b64id);
            if (id) {
                dispatch(getOrganisationDetail(id));
                dispatch(getOrganisationAgentList(token, user_id, id));
            } else {
                dispatch(getOrganisationAgentList(token, user_id));
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }

    const { loadingOrganisationDetail,
        OrganisationDetailError,
        OrganisationDetail,
        loadingOrganisationList,
        OrganisationListError,
        OrganisationList,
        loadingEmployeeList,
        EmployeeList,
        EmployeeListError,
        loadingOrganisationAgentList,
        OrganisationAgentList,
        OrganisationAgentListError,
    } = useSelector(state => state?.OrganisationListReducer);

    const [agentOptions, setAgentOptions] = useState([]);

    useEffect(() => {
        if (OrganisationAgentList) {
            let arr = [];
            OrganisationAgentList.map(v => { arr.push({ value: v.id, label: `${v.name} (${v.customerType})` }) });
            setAgentOptions(arr);
        } else {
            setAgentOptions([]);
        }
    }, [OrganisationAgentList]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values) => {
            setDisableSubmit(true);
            // console.log(values);
            setDisableSubmit(false);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/organization/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`flexichain/organization/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    //update the data in form
    useEffect(() => {
        if (loadingOrganisationDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (OrganisationDetail) {
            setDisableGeneralTab(false);
            if (OrganisationDetail.entity_type) {
                let parsed = JSON.parse(OrganisationDetail.entity_type)
                if (Array.isArray(parsed)) {
                    if (parsed.includes("shipper")) {
                        setDisableShipperTab(false);
                    } else {
                        setDisableShipperTab(true);
                    }

                    if (parsed.includes("consignee")) {
                        setDisableConsigneeTab(false);
                    } else {
                        setDisableConsigneeTab(true);
                    }

                    if (parsed.includes("services")) {
                        setDisableServicesTab(false);
                    } else {
                        setDisableServicesTab(true);
                    }

                    if (parsed.includes("agent")) {
                        setDisableAgentTab(false);
                    } else {
                        setDisableAgentTab(true);
                    }

                    if (parsed.includes("carrier")) {
                        setDisableCarrierTab(false);
                    } else {
                        setDisableCarrierTab(true);
                    }
                }
            }
        } else {
            setDisableGeneralTab(true);
        }

    }, [loadingOrganisationDetail, OrganisationDetailError, OrganisationDetail])


    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            formik.setFieldValue("entity_type", [...formik.values.entity_type, value]);
        } else {
            formik.setFieldValue(
                "entity_type",
                formik.values.entity_type.filter((item) => item !== value)
            );
        }
    };


    useEffect(() => {
        if (OrganisationDetail) {
            let entity_arr = [];
            if (OrganisationDetail.entity_type) {
                //convert entity type into string,
                let parsedArr = JSON.parse(OrganisationDetail.entity_type);
                if (Array.isArray(parsedArr)) {
                    entity_arr = parsedArr
                }
            }
            formik.setFieldValue("customerType", OrganisationDetail?.customerType);
            formik.setFieldValue("name", OrganisationDetail?.name);
            formik.setFieldValue("alias", OrganisationDetail?.alias);
            formik.setFieldValue("email", OrganisationDetail?.email);
            formik.setFieldValue("mobile", OrganisationDetail?.mobile);
            // formik.setFieldValue("gst_number", OrganisationDetail?.GST);
            // formik.setFieldValue("service_type", OrganisationDetail?.service_type);
            formik.setFieldValue("has_sub_agent", OrganisationDetail?.has_sub_agent);
            formik.setFieldValue("sub_agent_id", OrganisationDetail?.sub_agent_id);
            formik.setFieldValue("entity_type", entity_arr);
        }
    }, [OrganisationDetail]);


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <h4>Organisation Detail</h4>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    {/* Form */}
                                    <form onSubmit={formik.handleSubmit} >

                                        <div className="row d-flex justify-content-end">
                                            <div className="col-md-6 d-flex justify-content-end">
                                                <button type="button" className="btn btn-sm btn-danger" onClick={handleShowEditForm}>
                                                    <i className="fa-solid fa-pen-to-square" title="Edit Organisation"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">

                                                <input
                                                    type="checkbox"
                                                    className='me-2'
                                                    name="has_sub_agent"
                                                    id="has_sub_agent"
                                                    onChange={(e) => {
                                                        formik.setFieldValue("has_sub_agent", e.target.checked);
                                                        formik.setFieldValue("sub_agent_id", 0);
                                                    }}
                                                    checked={formik.values.has_sub_agent}
                                                    disabled={true}
                                                />
                                                <label htmlFor="" className='form-label mb-0'>
                                                    Sub Agent
                                                </label>
                                            </div>

                                            {formik.values.has_sub_agent && <div className="col-md-3">
                                                <label htmlFor="name" className='form-label mb-0'>
                                                    Sub Agent:
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        options={agentOptions}
                                                        styles={customStyles}
                                                        name="sub_agent_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('sub_agent_id', option.value);
                                                        }}
                                                        value={formik.values.sub_agent_id ? agentOptions.find(option => option.value == formik.values.sub_agent_id || null) : null}
                                                        isLoading={loadingOrganisationAgentList}
                                                        isDisabled={true}
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="" className='form-label mb-0'>
                                                    Type of Organisation
                                                </label>
                                                <select id="" className="form-control form-control-sm"
                                                    disabled={true}
                                                    name='customerType'
                                                    value={formik.values.customerType}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}>
                                                    <option value="">Select an option</option>
                                                    <option value="Individual/Proprietary firm">Individual/Proprietary firm</option>
                                                    <option value="Private or Public Limited Company">Private or Public Limited Company</option>
                                                    <option value="Partnership firm">Partnership firm</option>
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label htmlFor="name" className='form-label mb-0'>
                                                    Name
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        disabled={true}
                                                        id="name"
                                                        name='name'
                                                        value={formik.values.name}
                                                        onChange={(e) => {
                                                            const uppercasedValue = e.target.value.toUpperCase();
                                                            formik.setFieldValue('name', uppercasedValue);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="alias" className='form-label  mb-0'>
                                                    Alias
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        disabled={true}
                                                        id='alias'
                                                        name='alias'
                                                        value={formik.values.alias}
                                                        // onChange={formik.handleChange}
                                                        onChange={(e) => {
                                                            const uppercasedValue = e.target.value.toUpperCase();
                                                            formik.setFieldValue('alias', uppercasedValue);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="email" className='form-label  mb-0'>
                                                    Email
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        disabled={true}
                                                        id='email'
                                                        name='email'
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Mobile
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        name='mobile'
                                                        disabled={true}
                                                        value={formik.values.mobile}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="col-md-6">
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    GST Number
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        disabled={true}
                                                        name='gst_number'
                                                        value={formik.values.gst_number}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div> */}
                                            {/* <div className="col-md-6">
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Service Type
                                                </label>
                                                <div className=" mb-3 mb-sm-0">
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name='service_type'
                                                        disabled={true}
                                                        value={formik.values.service_type}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    >
                                                        <option value="" disabled>-Select a value-</option>
                                                        <option value="Custom Clearance">Custom Clearance</option>
                                                        <option value="Freight Forwarding">Freight Forwarding</option>
                                                        <option value="Both">Both</option>
                                                    </select>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="row my-2 mt-2">
                                            <div className="d-flex align-items-center flex-wrap row-gap-2 gap-2">
                                                <div className="form-check ">
                                                    <input type="checkbox"
                                                        disabled={true}
                                                        className="form-check-input "
                                                        name="entity_type"
                                                        id="shipper"
                                                        value="shipper"
                                                        onChange={handleCheckboxChange}
                                                        checked={formik.values.entity_type.includes("shipper")}
                                                    />
                                                    <label
                                                        className="form-label mb-0 mt-0"
                                                        htmlFor="shipper"

                                                    >
                                                        Shipper
                                                    </label>
                                                </div>

                                                <div className="form-check ">
                                                    <input type="checkbox"
                                                        disabled={true}
                                                        className="form-check-input " id="consignee"
                                                        name="entity_type"
                                                        value="consignee"
                                                        onChange={handleCheckboxChange}
                                                        checked={formik.values.entity_type.includes("consignee")} />
                                                    <label
                                                        className="form-label mb-0 mt-0"
                                                        name="entity_type"
                                                        htmlFor="consignee"
                                                    >
                                                        Consignee
                                                    </label>
                                                </div>
                                                <div className="form-check ">
                                                    <input type="checkbox"
                                                        disabled={true}
                                                        className="form-check-input " id="services"
                                                        name="entity_type"
                                                        value="services"
                                                        onChange={handleCheckboxChange}
                                                        checked={formik.values.entity_type.includes("services")} />
                                                    <label
                                                        className="form-label mb-0 mt-0"
                                                        htmlFor="services"

                                                    >
                                                        Services
                                                    </label>
                                                </div>
                                                <div className="form-check ">
                                                    <input type="checkbox"
                                                        disabled={true}
                                                        className="form-check-input " id="agent"
                                                        name="entity_type"
                                                        value="agent"
                                                        onChange={handleCheckboxChange}
                                                        checked={formik.values.entity_type.includes("agent")} />
                                                    <label
                                                        className="form-label mb-0 mt-0"
                                                        htmlFor="agent"

                                                    >
                                                        Agent
                                                    </label>
                                                </div>
                                                <div className="form-check ">
                                                    <input type="checkbox"
                                                        disabled={true}
                                                        className="form-check-input " id="carrier"
                                                        name="entity_type"
                                                        value="carrier"
                                                        onChange={handleCheckboxChange}
                                                        checked={formik.values.entity_type.includes("carrier")} />
                                                    <label
                                                        className="form-label mb-0 mt-0"
                                                        htmlFor="carrier"
                                                    >
                                                        Carrier
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    {/* Tabs */}
                                    <div className="row-gap-2">
                                        {/* <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link active" id="General-tab" data-bs-toggle="pill" data-bs-target="#General" type="button" role="tab" aria-controls="General" aria-selected="true">General</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Account-info-tab" data-bs-toggle="pill" data-bs-target="#Account-info" type="button" role="tab" aria-controls="Account Info" aria-selected="false">Account Info</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="IATA-tab" data-bs-toggle="pill" data-bs-target="#IATA" type="button" role="tab" aria-controls="IATA" aria-selected="false">IATA</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Reg-tab" data-bs-toggle="pill" data-bs-target="#Reg" type="button" role="tab" aria-controls="Reg" aria-selected="false">Reg</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Shipper-tab" data-bs-toggle="pill" data-bs-target="#Shipper" type="button" role="tab" aria-controls="Shipper" aria-selected="false">Shipper</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Consignee-tab" data-bs-toggle="pill" data-bs-target="#Consignee" type="button" role="tab" aria-controls="Consignee" aria-selected="false">Consignee</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Agent-tab" data-bs-toggle="pill" data-bs-target="#Agent" type="button" role="tab" aria-controls="Agent" aria-selected="false">Agent</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Service-tab" data-bs-toggle="pill" data-bs-target="#Service" type="button" role="tab" aria-controls="Service" aria-selected="false">Service</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Carrier-tab" data-bs-toggle="pill" data-bs-target="#Carrier" type="button" role="tab" aria-controls="Carrier" aria-selected="false">Carrier</button>
                                            </li>
                                        </ul> */}
                                        <div className="tab-content" id="pills-tabContent">
                                            <Tabs
                                                activeKey={activeTab} // Controlled by state
                                                onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                                transition={false}
                                                id="noanim-tab-example"
                                                className="nav nav-pills mb-3 custom-tabs gap-0"
                                            >
                                                <Tab eventKey="basic" title="KYC Detail" className="nav-item" disabled={disableGeneralTab}>
                                                    <BasicTab token={token} user_id={user_id} b64id={b64id} refresh={refresh} />
                                                </Tab>
                                                <Tab eventKey="general" title="General" className="nav-item" disabled={disableGeneralTab}>
                                                    <GeneralTab token={token} user_id={user_id} b64id={b64id} />
                                                </Tab>
                                                <Tab eventKey="shipper" title="Shipper" className="nav-item" disabled={disableShipperTab}>
                                                    <ShipperTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>
                                                <Tab eventKey="consignee" title="Consignee" className="nav-item" disabled={disableConsigneeTab}>
                                                    <ConsigneeTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>
                                                <Tab eventKey="services" title="Services" className="nav-item" disabled={disableServicesTab}>
                                                    <ServicesTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>
                                                <Tab eventKey="agent" title="Agent" className="nav-item" disabled={disableAgentTab}>
                                                    <AgentTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>
                                                <Tab eventKey="iata" title="IATA" className="nav-item">
                                                    <IATATab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>
                                                <Tab eventKey="reg" title="Reg" className="nav-item">
                                                    <RegTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                                </Tab>

                                            </Tabs>
                                            {/* <div className="tab-pane fade show active" id="General" role="tabpanel" aria-labelledby="General-tab">
                                                <GeneralTab token={token} user_id={user_id} b64id={b64id} />
                                            </div>
                                            <div className="tab-pane fade" id="Shipper" role="tabpanel" aria-labelledby="Shipper-tab">
                                                <ShipperTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                            </div>
                                            <div className="tab-pane fade" id="Consignee" role="tabpanel" aria-labelledby="Consignee-tab">
                                                <ConsigneeTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                            </div>
                                            <div className="tab-pane fade" id="Service" role="tabpanel" aria-labelledby="Service-tab">
                                                <ServicesTab token={token} user_id={user_id} b64id={b64id} OrganisationDetail={OrganisationDetail} refresh={refresh} OrganisationList={OrganisationList} EmployeeList={EmployeeList} />
                                            </div> */}
                                            {/* <div className="tab-pane fade" id="Agent" role="tabpanel" aria-labelledby="Agent-tab">
                                                <Agent />
                                            </div>
                                            <div className="tab-pane fade" id="Service" role="tabpanel" aria-labelledby="Service-tab">
                                                <ServicesTab /> 
                                            </div>

                                            <div className="tab-pane fade" id="Account-info" role="tabpanel" aria-labelledby="Account-info-tab">
                                                <AccountInfo />
                                            </div>
                                            <div className="tab-pane fade" id="Billing" role="tabpanel" aria-labelledby="Billing-tab">
                                                5
                                            </div>
                                            <div className="tab-pane fade" id="Carrier" role="tabpanel" aria-labelledby="Carrier-tab">
                                                <Carrier />
                                            </div>
                                            <div className="tab-pane fade" id="Reg" role="tabpanel" aria-labelledby="Reg-tab">
                                                <Reg />
                                            </div>
                                            <div className="tab-pane fade" id="IATA" role="tabpanel" aria-labelledby="IATA-tab">
                                                <Iata />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <EditOrganisationOffcanvas b64id={b64id} refresh={refresh} show={showEditForm} handleClose={handleCloseEditForm} OrganisationDetail={OrganisationDetail} agentOptions={agentOptions} loadingOrganisationAgentList={loadingOrganisationAgentList} />
        </>
    )
}

export default OrganisationEdit